import { memo } from 'react'

const ArrowRightIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox='0 0 16 16'
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M8.475 12.462a.493.493 0 0 0 .383 0 .493.493 0 0 0 .162-.109l3.987-3.987a.5.5 0 0 0 0-.732L9.02 3.647a.5.5 0 0 0-.707.706L11.46 7.5H3.333a.5.5 0 0 0 0 1h8.127l-3.147 3.147a.5.5 0 0 0 .162.815Z"
      clipRule="evenodd"
    />
  </svg>
)

export default memo(ArrowRightIcon)
